var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discount",style:({ 'background-image': _vm.backgroundImage ? `url(${_vm.backgroundImage})` : 'linear-gradient(to left, #FFB88C, #DE6262)' })},[_c('div',{staticClass:"discount-content"},[_c('h3',[_vm._v(_vm._s(_vm.discount.name))]),_c('span',[_vm._v(_vm._s(_vm.discount.short_description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }